<template>
  <div>
    <div class="head row ">
      <div class="col-md-12 help-head-wrap">
        <h3 class="pl-3">Help</h3>
        <a href="/settings/create-help" class="help-add-btn">
          <i class="fa fa-plus" style="line-height: inherit; font-size: 32px; cursor: pointer;"></i>
        </a>
      </div>
    </div>
    <div class="mail-in-wrap">
      <table class="table table-responsive table-hover">
        <thead>
        <tr>
          <th></th>
          <th>Auteur</th>
          <th>Naam</th>
          <th>Pagina</th>
          <th>Versie</th>
        </tr>
        </thead>
        <thead>
        <tr>
          <th></th>
          <th><input type="text" @keyup="filter()" v-model="search.author" placeholder="Zoeken..."
                     class="form-control"></th>
          <th><input type="text" @keyup="filter()" v-model="search.name" placeholder="Zoeken..." class="form-control">
          </th>
          <th><input type="text" @keyup="filter()" v-model="search.path" placeholder="Zoeken..."
                     class="form-control"></th>
          <th><input type="number" @keyup="filter()" v-model="search.version" placeholder="Zoeken..."
                     class="form-control"></th>
        </tr>
        </thead>
        <thead></thead>
        <tbody>
        <tr v-for="(help, index) in helppages" :key="index">
          <td>
            <div class="btn-group">
              <a :href="'/settings/edit-help/'+help.id" class="btn btn-primary"><i class="fas fa-pencil-alt"></i></a>
              <a data-toggle="modal" data-dismiss="modal" href="#helpDel" class="btn btn-danger"><i
                  class="fa fa-trash"></i></a>
            </div>
          </td>
          <td>{{ help.user.display_name }}</td>
          <td>{{ help.name }}</td>
          <td>{{ help.path }}</td>
          <td>{{ help.version }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div
        class="modal fade"
        id="helpDel"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content help-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="row">
              <div class="col-md-12 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 ">
                    <p>Weet je zeker dat je deze helppagina wilt verwijderen?</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer help-modal-footer pt-0">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-danger">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  components: {},
  computed: {},
  data() {
    return {
      helppages: [],
      search: {}
    }
  },
  created() {
    this.$store.dispatch('get', '/api/v1/help-pages')
        .then(data => {
          console.log(data.data)
          this.helppages = data.data.data
        })
        .catch(error => {
          console.log(error.request)
        })
  },
  methods: {
    filter() {
      
      this.$store.dispatch('post', {
        endpoint: '/api/v1/help-pages/filter',
        details: {search: this.search},
      })
          .then(response => {
            console.log(response.data.data)
            this.helppages = response.data.data
          })
          .catch(error => {
            console.log()
            console.log(error)
          })
    }
  }
}
</script>

<style lang="css" scoped>
.help-head-wrap {
  display: flex;
  justify-content: space-between;
}

.help-add-btn {
  color: black;
}

.help-modal-footer {
  border-top: none !important;
}
</style>